<template>
  <a v-if="object.file_url"
     :href="object.file_url"
     target="_blank">
    <LinkSvg class="svg-size-md svg-light"/>
  </a>
</template>

<script setup>
import LinkSvg from '@/assets/svg-vue/general/link.svg'

defineProps({
  object: {
    type: Object
  },
})
</script>
